(function(){
  'use strict';

  var source=document.getElementById('DeckauraMarketPricingData');
  if(!source)return;

  var data;
  try{data=JSON.parse(source.textContent||'{}');}catch(_){return;}

  var tiers=data.tiers||{};
  var variants=data.variants||{};
  var attributes=['aria-label','title','data-btn','data-note','data-price-label','value'];
  var directSelector='[data-market-price-tier],[data-market-price-variant]';
  var skipSelector='script,style,noscript,template,[data-deckaura-no-market-pricing]';
  var moneyCache=Object.create(null);
  var moneyFormatter=null;
  var priceTokenPattern=/(?:5[\.,]99|9[\.,]99|16[\.,]99|US\$|R\$|\$|\u20ac|\u00a3|\u20ba|\b(?:USD|EUR|GBP|BRL|TRY|TL)\b)/i;

  try{
    moneyFormatter=new Intl.NumberFormat(data.locale||document.documentElement.lang||'en',{
      style:'currency',currency:data.currency||'USD'
    });
  }catch(_){moneyFormatter=null;}

  function normalizedTier(value){
    var tier=String(value||'').toLowerCase().replace(/[^a-z]/g,'');
    if(tier==='standard'||tier==='deep'||tier==='quick'||tier==='essential')return'essential';
    if(tier==='medium'||tier==='deeper'||tier==='focused')return'focused';
    if(tier==='premium'||tier==='full'||tier==='indepth')return'indepth';
    if(tier==='membership'||tier==='club')return'club';
    return tier;
  }

  function tierEntry(tier){return tiers[normalizedTier(tier)]||null;}
  function variantEntry(id){return variants[String(id||'')]||null;}

  function fallbackMoney(cents){
    var amount=Number(cents);
    if(!Number.isFinite(amount))return'';
    var cacheKey=String(amount);
    if(Object.prototype.hasOwnProperty.call(moneyCache,cacheKey))return moneyCache[cacheKey];
    var formatted='';
    try{
      formatted=moneyFormatter?moneyFormatter.format(amount/100):(amount/100).toFixed(2)+' '+String(data.currency||'USD');
    }catch(_){formatted=(amount/100).toFixed(2)+' '+String(data.currency||'USD');}
    moneyCache[cacheKey]=formatted;
    return formatted;
  }

  function formatTier(tier,fallbackCents){
    var entry=tierEntry(tier);
    return fallbackMoney(entry&&entry.priceCents!=null?entry.priceCents:fallbackCents);
  }

  function formatVariant(id,fallbackCents){
    var entry=variantEntry(id);
    return fallbackMoney(entry&&entry.priceCents!=null?entry.priceCents:fallbackCents);
  }

  function replaceLiteral(value,token,replacement){
    if(!token||!replacement||token===replacement)return value;
    return value.split(token).join(replacement);
  }

  function replaceKnownCurrencyToken(value,amount,replacement){
    if(!replacement)return value;
    var escaped=String(amount).replace('.', '[\\.,]');
    // When the requested amount is an integer (for example the $100 club
    // tier), do not match the integer portion of an already formatted
    // decimal. Otherwise "$100.00" becomes "$100.00.00" on the second pass.
    var amountTail=String(amount).indexOf('.')<0?'(?![\\d\\.,])':'(?!\\d)';
    var prefix=new RegExp('(?:US\\$|R\\$|\\$|€|£|₺|TL)\\s*'+escaped+amountTail,'gi');
    var suffix=new RegExp('(^|[^0-9])('+escaped+'\\s*(?:USD|EUR|GBP|BRL|TRY|TL|US\\$|R\\$|\\$|€|£|₺))','gi');
    return value.replace(prefix,replacement).replace(suffix,function(match,leading){return leading+replacement;});
  }

  function pricingContext(element){
    return !!(element&&element.closest&&element.closest(
      directSelector+',[class*="price"],[class*="tier"],[class*="offer"],[class*="package"],[data-tier],[data-paid-tier]'
    ));
  }

  function replaceBarePrice(value,amount,replacement,element,force){
    if(!replacement||(!force&&!pricingContext(element)))return value;
    if(/(?:US\$|R\$|\$|€|£|₺|\b(?:USD|EUR|GBP|BRL|TRY|TL)\b)/i.test(value))return value;
    var escaped=String(amount).replace('.', '[\\.,]');
    var amountTail=String(amount).indexOf('.')<0?'(?![\\d\\.,%])':'(?![\\d%])';
    var bare=new RegExp('(^|[^0-9])('+escaped+')'+amountTail,'g');
    return value.replace(bare,function(match,leading){return leading+replacement;});
  }

  function localizeText(value,element){
    var output=String(value==null?'':value);
    var startingPrice=/(?:\bfrom\b|\bstarting\b|\bdesde\b|\ba partir de\b|\bab\b|başlayan)/i.test(output);
    var monthlyPrice=/(?:\bmonth(?:ly)?\b|\bmes\b|\bmês\b|aylık|por mês)/i.test(output);
    var bareClubPrice=monthlyPrice&&/(^|[^0-9])100(?:[\.,]00)?(?![\d%])/i.test(output);
    if(!priceTokenPattern.test(output)&&!bareClubPrice)return output;
    Object.keys(tiers).forEach(function(tier){
      var entry=tiers[tier],replacement=formatTier(tier);
      if(!entry||!replacement)return;
      output=replaceLiteral(output,entry.formattedWithCurrency,replacement);
      output=replaceLiteral(output,entry.formatted,replacement);
    });
    output=replaceKnownCurrencyToken(output,'16.99',formatTier('indepth'));
    output=replaceKnownCurrencyToken(output,'9.99',formatTier(startingPrice?'essential':'focused'));
    output=replaceKnownCurrencyToken(output,'5.99',formatTier('essential'));
    output=replaceKnownCurrencyToken(output,'100.00',formatTier('club'));
    output=replaceKnownCurrencyToken(output,'100',formatTier('club'));
    output=replaceBarePrice(output,'16.99',formatTier('indepth'),element);
    output=replaceBarePrice(output,'9.99',formatTier(startingPrice?'essential':'focused'),element,startingPrice);
    output=replaceBarePrice(output,'5.99',formatTier('essential'),element);
    output=replaceBarePrice(output,'100.00',formatTier('club'),element,monthlyPrice);
    output=replaceBarePrice(output,'100',formatTier('club'),element,monthlyPrice);
    return output;
  }

  function applyDirectPrice(element){
    if(!element||!element.matches||!element.matches(directSelector))return;
    var label='';
    if(element.hasAttribute('data-market-price-variant')){
      label=formatVariant(element.getAttribute('data-market-price-variant'));
    }else{
      label=formatTier(element.getAttribute('data-market-price-tier'));
    }
    if(!label)return;
    var prefix=element.getAttribute('data-market-price-prefix')||'';
    var suffix=element.getAttribute('data-market-price-suffix')||'';
    element.textContent=prefix+label+suffix;
  }

  function applyElement(element){
    if(!element||element.nodeType!==1||element.matches(skipSelector)||element.closest('[data-deckaura-no-market-pricing]'))return;
    applyDirectPrice(element);
    attributes.forEach(function(attribute){
      if(!element.hasAttribute(attribute))return;
      var current=attribute==='value'&&'value' in element?element.value:element.getAttribute(attribute);
      var replacement=localizeText(current,element);
      if(replacement===current)return;
      if(attribute==='value'&&'value' in element)element.value=replacement;
      else element.setAttribute(attribute,replacement);
    });
  }

  function applyText(node){
    if(!node||node.nodeType!==3||!node.parentElement||node.parentElement.closest(skipSelector+', [data-deckaura-no-market-pricing]'))return;
    var replacement=localizeText(node.nodeValue,node.parentElement);
    if(replacement!==node.nodeValue)node.nodeValue=replacement;
  }

  function apply(root){
    if(!root)return;
    if(root.nodeType===3){applyText(root);return;}
    if(root.nodeType!==1&&root.nodeType!==9&&root.nodeType!==11)return;
    if(root.nodeType===1)applyElement(root);
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT);
    var node;
    while((node=walker.nextNode())){
      if(node.nodeType===3)applyText(node);else applyElement(node);
    }
  }

  window.DeckauraMarketPricing={
    data:data,
    getTier:tierEntry,
    getVariant:variantEntry,
    formatTier:formatTier,
    formatVariant:formatVariant,
    localizeText:localizeText,
    apply:apply
  };

  document.documentElement.setAttribute('data-market-country',String(data.country||''));
  document.documentElement.setAttribute('data-market-currency',String(data.currency||''));
  apply(document.body);

  if(document.body){
    new MutationObserver(function(records){
      records.forEach(function(record){
        if(record.type==='characterData')applyText(record.target);
        else if(record.type==='attributes')applyElement(record.target);
        else Array.prototype.forEach.call(record.addedNodes,apply);
      });
    }).observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:attributes});
  }

  window.dispatchEvent(new CustomEvent('deckaura:market-pricing-ready',{detail:data}));
})();
